"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = void 0;
function groupBy(arr, keyGetter) {
    var grouped = new Map();
    arr.forEach(function (value) {
        var key = keyGetter(value);
        var group = grouped.get(key);
        if (!group) {
            grouped.set(key, [value]);
        }
        else {
            group.push(value);
        }
    });
    return grouped;
}
exports.groupBy = groupBy;
